import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/posts';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { useSeo } from '@/hooks/useSeo';
import { site } from '@/utils/site';

export default function FaqPage() {
  useSeo({
    title: '常见问题_黑料看点使用说明与内容问答',
    description:
      '黑料看点常见问题解答：网站内容是否免费、更新频率、如何判断高能片段、如何推荐名场面以及内容纠错方式，一次说清。',
    keywords: '黑料看点常见问题,黑料看点怎么用,黑料看点更新,黑料看点投稿',
    path: '/faq',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
          { '@type': 'ListItem', position: 2, name: '常见问题' },
        ],
      },
    ],
  });

  return (
    <SiteLayout>
      <section className="w-full px-4 md:px-8 pt-24 md:pt-32 pb-10 md:pb-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <Breadcrumbs items={[{ label: '首页', to: '/' }, { label: '常见问题' }]} />
          <h1 className="mt-5 font-heading text-3xl md:text-5xl text-foreground-950">常见问题</h1>
          <p className="mt-4 max-w-2xl text-sm md:text-base text-foreground-600 leading-8">
            关于黑料看点怎么用、内容怎么来、如何参与推荐，这里整理了最常被问到的几个问题。没找到答案的话，欢迎直接给我们留言。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-8">
            <FaqAccordion items={faqs} defaultOpen={0} tone="plain" />
          </div>

          <aside className="lg:col-span-4">
            <div className="bg-background-100 rounded-lg border border-background-200 p-6 lg:sticky lg:top-24">
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
                <i className="ri-question-answer-line" />
              </span>
              <h2 className="mt-4 font-heading text-xl text-foreground-950">还有别的问题？</h2>
              <p className="mt-3 text-sm text-foreground-600 leading-7">
                关于内容合作、名场面推荐或页面纠错，都可以通过留言表单直接联系我们，编辑团队通常会在两个工作日内回复。
              </p>
              <Link
                to="/contact"
                className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                <i className="ri-mail-send-line" />
                前往留言
              </Link>
              <div className="mt-6 pt-5 border-t border-background-200 space-y-2 text-xs text-foreground-500">
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line" />
                  {site.email}
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-time-line" />
                  工作日 09:00 - 18:00
                </p>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </SiteLayout>
  );
}